import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { DownloadOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Button, Typography, Select, Form, notification, Tooltip } from 'antd';
import { CSVLink } from 'react-csv';
import { reportData } from '../../redux/actions/customFunction';
import {
  intialPaginationState,
  showingPageTotalRange,
  unexpectedError,
  formItemLayout,
  tailFormItemLayout,
  PictureCell,
} from '../../common_functions';
import moment from 'moment';
import { FilePdfOutlined } from '@ant-design/icons';
import PrintAdvanceSearchModal from '../modals/PrintAdvanceSearchModal';
import CollectionLocationsForm from './common-comp/CollectionLocationsForm';

const BasicPrint = props => {
  const { id: reportType } = useParams();
  const formRef = useRef(null);
  const childFormRef = useRef(null);
  const csvLink = useRef(null);
  const { roleType, collections_permissions, prints_negatives_obj, getItems, basicReport, saveItem } = props;
  const [reports, setReports] = useState([]);
  const [allData, setAllData] = useState([]);
  const [collections, setCollections] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const todayDateTime = moment().format('MM-DD-YYYY-HH-mm-ss');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sortParameters, setSortingParameters] = useState(false);

  const columns = [
    {
      title: 'Print Object ID',
      dataIndex: 'object_id',
      key: 'object_id',
      render: text => <>{text.id}</>,
    },
    {
      title: 'Collection Name',
      dataIndex: 'object_id',
      key: 'object_id',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text.collections.name}</span>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'ID',
      dataIndex: 'acq_id',
      key: 'acq_id',
      sorter: true,
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      sorter: true,
    },
    {
      title: 'Common Title',
      dataIndex: 'common_title',
      key: 'common_title',
      sorter: true,
    },
    {
      title: 'Thumbnail',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      align: 'center',
      render: text => (text ? <PictureCell dataIndexValue={text} getFile={props.getFile} width={50} /> : <span>-</span>),
    },
    {
      title: 'Object',
      dataIndex: 'object',
      key: 'object',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Print',
      dataIndex: 'print',
      key: 'print',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Physical Characteristics',
      dataIndex: 'phy_char',
      key: 'phy_char',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'XRF',
      dataIndex: 'xrf',
      key: 'xrf',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Micrometer',
      dataIndex: 'micrometer',
      key: 'micrometer',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Glossmeter',
      dataIndex: 'glossmeter',
      key: 'glossmeter',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Photospectrometer',
      dataIndex: 'photo_spectro_meter',
      key: 'photo_spectro_meter',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Image Description',
      dataIndex: 'image_description',
      key: 'image_description',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Mount Characteristics',
      dataIndex: 'print_mount_conditions',
      key: 'print_mount_conditions',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Basic Photos',
      dataIndex: 'basic_photos',
      key: 'basic_photos',
      render: text => <span style={{ textTransform: 'capitalize' }}>{text == 1 ? 'Complete' : 'Incomplete'}</span>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Tooltip placement="top" title="Generate Pdf">
            <FilePdfOutlined onClick={e => generatePDF(record.object_id.id, [record])} />
          </Tooltip>
        </span>
      ),
    },
  ];
  //Get collection data

  useEffect(() => {
    const fetchData = async () => {
      const { data: collection_data } = await getItems('collections', {
        fields: ['id', 'name'],
        sort: '-id',
        limit: -1,
        filters: {
          associated_to: {
            _in: ['print', 'both'],
          },
        },
      });
      setCollections(collection_data);
      await getColData(pagination);
    };
    fetchData();
  }, []);

  // const getColData = async (pagination, filters = {}, csv = false, searchType = 'basic_search') => {
  //   try {
  //     setLoading(true);
  //     const collections = formRef.current.getFieldValue('collections');
  //     const acquisitionID = childFormRef?.current?.getFieldValue('acquisition');
  //     const portfolioAddNumber = childFormRef?.current?.getFieldValue('portfolio_add_number');
  //     const commonTitle = childFormRef?.current?.getFieldValue('object_name');

  //     const isAdmin = roleType === 'admin';
  //     const hasCollectionsPermission = collections_permissions.view.length > 0;
  //     const hasPrintNegatives = prints_negatives_obj.length > 0;

  //     let printFilters = {};
  //     const params = csv
  //       ? { limit: '-1' }
  //       : {
  //           offset: pagination.pageSize * (pagination.current - 1),
  //           limit: pagination.pageSize,
  //           meta: 'filter_count',
  //         };
  //     // if user is admin user
  //     if (isAdmin) {
  //       if (collections) {
  //         filters.collections = { _eq: collections };
  //       }
  //     } else if (hasCollectionsPermission && hasPrintNegatives) {
  //       //if user is not an admin user but have a collections and prints object permissions
  //       filters.object_id = { _in: prints_negatives_obj };
  //       // collection selected
  //       if (collections) {
  //         filters['_and'] = [{ collections: { id: { _in: collections_permissions.view } } }, { collections: { _eq: collections } }];
  //       } else {
  //         filters.collections = { _in: collections_permissions.view };
  //       }
  //     }

  //     if (searchType === 'advanced_search') {
  //       if (acquisitionID) {
  //         filters['acq_id'] = { _icontains: acquisitionID };
  //       }

  //       let port = {};
  //       let object_name = {};
  //       let objectIds = {};
  //       const andConditions = [];
  //       if (filters?.object_id) {
  //         delete filters.object_id
  //         objectIds = { object_id: { id: { _in: prints_negatives_obj } } };
  //       }

  //       if (portfolioAddNumber) {
  //         port = { object_id: { print: { portfolio_add_number: { _eq: portfolioAddNumber } } } };
  //       }
  //       if (commonTitle) {
  //         object_name = { object_id: { print: { object_name: { _icontains: commonTitle } } } };
  //       }
  //       if (Object.keys(objectIds).length > 0) {
  //         andConditions.push(objectIds);
  //       }
  //       if (Object.keys(port).length > 0) {
  //         andConditions.push(port);
  //       }
  //       if (Object.keys(object_name).length > 0) {
  //         andConditions.push(object_name);
  //       }
  //       if (andConditions.length > 0) {
  //         printFilters['_and'] = andConditions;
  //       }
  //     }
  //     if (isAdmin || hasPrintNegatives) {
  //       const response = await getItems('basic_print_reports', {
  //         fields: ['*,object_id.id,object_id.collections.name'],
  //         sort: '-id',
  //         filters: { ...filters, ...printFilters },
  //         ...params,
  //       });

  //       if (csv) {
  //         setAllData(reportData(response.data));
  //       } else {
  //         pagination.total = response.meta.filter_count;
  //         setPagination(pagination);
  //         setReports(response.data);
  //         setSelectedRowKeys({});
  //       }
  //     }
  //   } catch (error) {
  //     unexpectedError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getColData = async (pagination, filters = {}, csv = false, searchType = 'basic_search', sortParam = '-id') => {
    setSortingParameters(sortParam);
    try {
      setLoading(true);
      // Safely get form values
      const collections = formRef.current?.getFieldValue('collections') || null;
      const location = formRef.current?.getFieldValue('locations') || null;
      const isAdmin = roleType === 'admin';
      const hasCollectionsPermission = collections_permissions?.view?.length > 0;
      const hasPrintNegatives = prints_negatives_obj?.length > 0;
      const andConditions = [];

      // Validate permissions
      if (!isAdmin && !(hasCollectionsPermission && hasPrintNegatives)) {
        console.warn('User lacks required permissions');
        return;
      }

      // Prepare base params
      const params = {
        fields: ['*,object_id.id,object_id.collections.name,object_id.title'],
        // sort: '-id',
        sort: sortParam,
        ...(csv
          ? { limit: '-1' }
          : {
              offset: pagination.pageSize * (pagination.current - 1),
              limit: pagination.pageSize,
              meta: 'filter_count',
            }),
      };
      if (location) {
        andConditions.push({ object_id: { location: { _eq: location } } });
      }
      // Build filters
      const finalFilters = { ...filters };

      // Collection filters
      if (collections) {
        finalFilters.collections = isAdmin
          ? { _eq: collections }
          : {
              _and: [{ id: { _in: collections_permissions.view } }, { _eq: collections }],
            };
      } else if (!isAdmin) {
        finalFilters.collections = { _in: collections_permissions.view };
      }

      // Advanced search filters
      if (formSubmitted || searchType === 'advanced_search') {
        const andConditions = [];
        const acquisitionID = childFormRef?.current?.getFieldValue('acquisition')?.trim();
        const portfolioAddNumber = childFormRef?.current?.getFieldValue('portfolio_add_number');
        const commonTitle = childFormRef?.current?.getFieldValue('object_name')?.trim();

        if (acquisitionID) {
          finalFilters.acq_id = { _icontains: acquisitionID };
        }

        if (portfolioAddNumber) {
          andConditions.push({
            object_id: { print: { portfolio_add_number: { _eq: portfolioAddNumber } } },
          });
        }

        if (commonTitle) {
          andConditions.push({
            object_id: { print: { object_name: { _icontains: commonTitle } } },
          });
        }

        if (!isAdmin) {
          andConditions.push({ object_id: { id: { _in: prints_negatives_obj } } });
        }
      }

      if (andConditions.length > 0) {
        finalFilters._and = [...(finalFilters._and || []), ...andConditions];
      }

      // API call
      const response = await getItems('basic_print_reports', {
        ...params,
        filters: finalFilters,
      });

      if (!response) {
        throw new Error('No response from API');
      }

      // Handle response
      if (csv) {
        setAllData(reportData(response.data));
      } else {
        setPagination({
          ...pagination,
          total: response.meta?.filter_count || 0,
        });
        setReports(response.data || []);
        setSelectedRowKeys({});
      }
    } catch (error) {
      console.error('Error in getColData:', error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  // const handleTableChange = async pagination => {
  //   setPagination(pagination);
  //   await getColData(pagination, {}, false);
  // };

  const handleTableChange = async (pagination, filters, sorter) => {
    let sortField = sorter.field;
    let sortOrder = sorter.order === 'ascend' ? '' : '-'; // ASC = field, DESC = -field
    let sortParam = sortField ? `${sortOrder}${sortField}` : '-id';
    setPagination(pagination);
    await getColData(pagination, {}, false, 'basic_search', sortParam);
  };

  const extractCollectionsAndTitles = data => {
    const titlesArray = [];
    const collectionsSet = new Set();

    for (const item of data) {
      if (item?.object_id?.title) {
        titlesArray.push(item.object_id.title);
      }
      if (item?.object_id?.collections?.name && !collectionsSet.has(item.object_id.collections.name)) {
        collectionsSet.add(item.object_id.collections.name);
      }
    }

    return {
      objTitlesArray: titlesArray,
      collectionsNamesArray: [...collectionsSet],
    };
  };

  const generatePDF = async (id = null, rowsOverride = null) => {
    setLoading(true);
    try {
      let selectedIds = id ? [id] : [].concat(...Object.values(selectedRowKeys));

      if (selectedIds.length === 0) {
        notification.info({
          message: 'No data has been selected for PDF generation!',
          duration: 2,
        });
        return;
      }

      if (selectedIds.length > 100) {
        notification.info({
          message: 'Please select 100 records or fewer!',
          duration: 2,
        });
        return;
      }

      const { collectionsNamesArray, objTitlesArray } = extractCollectionsAndTitles(rowsOverride || selectedRows);

      const reportHistoryData = {
        number_of_records_in_pdf: selectedIds.length,
        collection_obj: {
          create: selectedIds.map(objId => ({
            report_history_id: '+',
            collection_obj_id: { id: objId },
          })),
          update: [],
          delete: [],
        },
        report_type: reportType === 'catalog-report' ? 1 : 2,
        collections: JSON.stringify(collectionsNamesArray),
        object_titles: JSON.stringify(objTitlesArray),
        status: 'draft',
        sort_by: sortParameters,
      };

      await saveItem('report_history', reportHistoryData);

      notification.success({
        message:
          'We will notify you via email upon completion of the report generation. You can view the report in the Report History tab.',
        duration: 2,
      });

      if (!id) setSelectedRowKeys({});
    } catch (error) {
      console.error('Report generation error:', error);
      notification.error({
        message: 'An error occurred during the report generation process!',
        duration: 2,
      });
    } finally {
      setSelectedRows([]);
      setSelectedRowKeys({});
      setLoading(false);
    }
  };

  // const generatePDF = async (id = null) => {
  //   setLoading(true);
  //   try {
  //     // Generate PDF based on conditions
  //     let resultArray = [].concat(...Object.values(selectedRowKeys));
  //     if (id) {
  //       resultArray = [];
  //       resultArray.push(id);
  //     }
  //     if (resultArray.length === 0) {
  //       notification.info({
  //         message: 'No data has been selected for PDF generation!',
  //         duration: 2,
  //       });
  //     }
  //     // if (resultArray.length > 20) {
  //     //   notification.info({
  //     //     message: 'Please select 20 records or fewer!',
  //     //     duration: 2,
  //     //   });
  //     // }
  //     else if (resultArray.length > 0) {
  //       let data = { object_ids: resultArray, sort: sortParameters };
  //       basicReport(data, reportType);
  //       notification['success']({
  //         message:
  //           'We will notify you via email upon completion of the report generation. You can view the report in the Report History tab.',
  //         duration: 2,
  //       });
  //       // if (!id) {
  //       //   setSelectedRowKeys({});
  //       // }
  //     }
  //   } catch (error) {
  //     notification['error']({
  //       message: 'An error occurred during the report generation process!',
  //       duration: 2,
  //     });
  //   } finally {
  //     setSelectedRows([]);
  //     setSelectedRowKeys({});
  //     setLoading(false);
  //   }
  // };

  const rowSelection = {
    selectedRowKeys: selectedRows.map(row => row.object_id.id),
    preserveSelectedRowKeys: true,
    onChange: (selKey, rows) => {
      setSelectedRowKeys(selKey);
      setSelectedRows(rows);
    },
  };

  const downloadCSV = () => {
    if (selectedRows.length === 0) {
      notification.info({
        message: 'No records selected for CSV download!',
        duration: 2,
      });
      return;
    }
    // Update state and trigger download after state update
    setAllData(reportData(selectedRows));
    setTimeout(() => {
      if (csvLink.current) {
        csvLink.current.link.click();
      }
      // Clear selection after download
      setSelectedRows([]);
      setSelectedRowKeys({});
      setAllData([]);
    }, 500); // Delay to ensure state is updated
  };
  const handleClose = () => {
    setIsModalVisible(false);
  };
  const handleCancel = async () => {
    if (!formSubmitted) {
      childFormRef.current?.resetFields();
    }
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const onFinish = async values => {
    if (!values.collections && !values.locations) {
      notification.error({
        message: 'Please select at least one field: Collection or Location to perform the search.',
        duration: 2,
      });
    } else {
      await getColData(intialPaginationState, {}, false, 'basic_search');
      setDisabled(false);
    }
  };
  const onFinishChild = async values => {
    if (!values?.acquisition && !values?.object_name && !values?.portfolio_add_number) {
      notification.error({
        message: 'All fields are empty. Please fill out at least one to perform the search.',
        duration: 2,
      });
    } else {
      await getColData(intialPaginationState, {}, false, 'advanced_search');
      setFormSubmitted(true);
      setDisabled(false);
      handleClose();
    }
  };
  const resetFilters = async (isChild = false) => {
    if (isChild) {
      childFormRef.current?.resetFields();
      setFormSubmitted(false);
    } else {
      formRef.current?.resetFields();
      childFormRef.current?.resetFields();
      setDisabled(true);
    }
    await getColData(intialPaginationState);

    setFormSubmitted(false);
  };

  const childResetFiters = async () => resetFilters(true);
  return (
    <Row className={!!loading ? 'disabledComponent' : ''}>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Reports", href: `/reports/cataloging-report/${reportType}` }, { title: "Cataloging Report", href: `/reports/cataloging-report/${reportType}` }, { title: reportType === 'catalog-report' ? 'Catalog Report' : 'Basic Reports' }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section report-buttons-row" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Reports
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end" align="right">
              <Button style={{ marginRight: '8px' }} icon={<FilePdfOutlined />} type="primary" size="small" onClick={e => generatePDF()}>
                Generate Pdf
              </Button>
              <Button icon={<DownloadOutlined />} type="primary" size="small" disabled={selectedRows.length === 0} onClick={downloadCSV}>
                Download Csv
              </Button>
              <CSVLink ref={csvLink} data={allData} filename={`basic_report_${todayDateTime}.csv`} style={{ display: 'none' }}></CSVLink>
            </Col>
          </Row>
          <CollectionLocationsForm
            props={props}
            onFinish={onFinish}
            formRef={formRef}
            showAdvanceSearchModal={showModal}
            resetFilters={resetFilters}
            disabled={disabled}
          />

          {/* <Form ref={formRef} layout="vertical" onFinish={onFinish} {...formItemLayout} initialValues={{ layout: tailFormItemLayout }}>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8}>
                <Form.Item name="collections" label="Collection">
                  <Select
                    placeholder="Select collection"
                    optionFilterProp="children"
                    allowClear
                    filterOption={(input, option) => option.children.includes(input)}
                    // onChange={async () => {
                    //   await getColData(intialPaginationState);
                    // }}
                  >
                    {collections.map(col => {
                      return <Select.Option key={col.id} value={col.id}>{col.name}</Select.Option>;
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Form.Item>
                <Button
                  type="primary"
                  size="small"
                  htmlType="submit"
                  style={{
                    marginTop: '28px',
                    height: '42px',
                  }}
                  icon={<SearchOutlined />}
                >
                  Search
                </Button>
                <Button
                  style={{
                    marginTop: '28px',
                    height: '42px',
                    marginLeft: '10px',
                  }}
                  className="report-button-margin-right"
                  icon={<SearchOutlined />}
                  type="primary"
                  size="small"
                  onClick={showModal}
                >
                  Advanced Search
                </Button>
                <Button
                  size="small"
                  danger
                  style={{
                    height: '42px',
                    marginTop: '28px',
                  }}
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    resetFilters();
                  }}
                  disabled={disabled}
                >
                  Reset all filters
                </Button>
              </Form.Item>
            </Row>
          </Form> */}

          {/* <hr /> */}
          <div className="artist-list" style={{ marginTop: '20px' }}>
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowSelection={rowSelection}
              rowKey={record => record.object_id.id}
              dataSource={reports}
              pagination={reports.length > 0 ? { ...pagination, ...showingPageTotalRange } : false}
              loading={loading}
              onChange={handleTableChange}
            />
            <PrintAdvanceSearchModal
              visible={isModalVisible}
              onClose={handleCancel}
              onFinish={onFinishChild}
              formRef={childFormRef}
              resetFilters={childResetFiters}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default BasicPrint;
